document.addEventListener('DOMContentLoaded', function () {
  const dataEl = document.querySelector('[data-ig-items]');
  if (!dataEl) return;
  const items = JSON.parse(dataEl.textContent);

  function tileHTML(it, i) {
    // Video tiles show a static poster frame in the grid (no autoplay) — playback only
    // starts once the viewer opens the lightbox for that tile.
    const media =
      it.type === 'video' && it.video
        ? `<video src="${it.video}" poster="${it.img}" muted loop playsinline preload="metadata"></video>`
        : `<img src="${it.img}" alt="${it.label}">`;
    return `<div class="ig-tile" data-i="${i}">${media}</div>`;
  }
  function bindTiles(container) {
    container.querySelectorAll('.ig-tile').forEach((t) => {
      t.addEventListener('click', () => {
        if (window.SiscodeLightbox) window.SiscodeLightbox.open(items[parseInt(t.dataset.i, 10)]);
      });
    });
  }

  function renderPlainGrid(container, count) {
    if (!container) return;
    const shown = items.slice(0, count);
    container.innerHTML = shown.map(tileHTML).join('');
    bindTiles(container);
  }

  const desktopGrid = document.querySelector('[data-ig-grid]');
  const mobileGrid = document.querySelector('[data-ig-grid-mobile]');

  const igSection = document.querySelector('.ig-section');
  function mountGrids() {
    renderPlainGrid(desktopGrid, 10);
    renderPlainGrid(mobileGrid, 9);
  }
  if (igSection && 'IntersectionObserver' in window) {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          mountGrids();
          sectionObserver.disconnect();
        }
      },
      { rootMargin: '600px 0px' }
    );
    sectionObserver.observe(igSection);
  } else {
    mountGrids();
  }
});
